export class Leaflet {


  constructor(container) {
    this.container = container;
    this.defaultOptions = {
      maxZoom: 19,
      attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
      subdomains: ["", "1", "2", "3", "4"],
      type: 'normal',
      format: 'jpg',
      bounds: [[46.35877, 8.782379], [49.037872, 17.189532]]
    };
    this.layers = {
      'default': {
        url: 'https://maps{s}.wien.gv.at/basemap/bmaphidpi/{type}/google3857/{z}/{y}/{x}.{format}',
        options: {}
      },
      'ortho': {
        url: 'https://maps{s}.wien.gv.at/basemap/bmaporthofoto30cm/{type}/google3857/{z}/{y}/{x}.{format}',
        options: {
          maxZoom: 20
        }
      },
      'gray': {
        url: 'https://maps{s}.wien.gv.at/basemap/bmapgrau/{type}/google3857/{z}/{y}/{x}.{format}',
        options: {
          format: 'png',
        }
      },
      'overlay': {
        url: 'https://maps{s}.wien.gv.at/basemap/bmapoverlay/{type}/google3857/{z}/{y}/{x}.{format}',
        options: {
          format: 'png',
        }
      }
    };

    this.initialZoom = parseInt(this.container.dataset.zoom ?? 12, 10);
    if (this.initialZoom > 19) {
      this.initialZoom = 19;
    }
    if (this.initialZoom < 1) {
      this.initialZoom = 1;
    }

    this.init();
  }

  addLayer(name)
  {
    const layer = L.tileLayer(this.layers[name].url, Object.assign(
      {},
      this.defaultOptions,
      this.layers[name].options)
    );
    layer.addTo(this.map);
  }

  init() {
    const el = this.container.querySelector('.map');

    let view = this.container.dataset.view ?? 'default';

    if (!this.layers.hasOwnProperty(view)) {
      view = 'default';
    }
    const center = [parseFloat(this.container.dataset.lat), parseFloat(this.container.dataset.lng)];

    this.map = L.map(el, {
      center: center,
      zoom: this.initialZoom,
      scrollWheelZoom: 'center'
    });

    let marker = L.icon({
      iconUrl: '/assets/images/marker_s.png',
      iconSize:     [32, 64], // size of the icon
      // shadowSize:   [50, 64], // size of the shadow
      iconAnchor:   [15, 53], // point of the icon which will correspond to marker's location
      //shadowAnchor: [4, 62],  // the same for the shadow
      //popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
    });

    this.addLayer(view);

    if (view === 'ortho') {
      this.addLayer('overlay');
    }

    L.marker(center, {icon: marker}).addTo(this.map).on('click', this.clickZoom.bind(this));
  }

  clickZoom(e)
  {
    this.map.setView(e.target.getLatLng(), this.initialZoom);
  }

}
